import { ChevronLeftIcon, ChevronRightIcon } from '@/components/icons';
import { Button } from './Button';
import styles from '@/styles/components/Pagination/style.scss';

interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

/** "Showing 21–40 of 57" with Previous / Next. The server does the paging; this only asks for a page. */
export function Pagination({ page, pageSize, total, onPageChange }: PaginationProps) {
  if (total === 0) return null;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);

  return (
    <nav aria-label="Pages" className={styles.bar}>
      <span className={styles.summary}>
        Showing <strong>{from}–{to}</strong> of <strong>{total}</strong>
      </span>
      {pages > 1 && (
        <div className={styles.buttons}>
          <Button size="sm" variant="secondary" icon={<ChevronLeftIcon size={15} />} onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
            Previous
          </Button>
          <span className={styles.page}>
            Page {page} of {pages}
          </span>
          <Button size="sm" variant="secondary" onClick={() => onPageChange(page + 1)} disabled={page >= pages}>
            Next
            <ChevronRightIcon size={15} />
          </Button>
        </div>
      )}
    </nav>
  );
}
